import { render, staticRenderFns } from "./BlockOverlay.vue?vue&type=template&id=03319aba&"
import script from "./BlockOverlay.vue?vue&type=script&lang=js&"
export * from "./BlockOverlay.vue?vue&type=script&lang=js&"
import style0 from "./BlockOverlay.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports